import React from 'react';
import { Button } from 'reactstrap';
import Icon from '~/components/icon/icon';
import styles from './styles.css';

const AddButton = ({ children, ...props }) => (
  <Button {...props}>
    <Icon className={`${styles.icon} stroke-white mr2`} icon="add-circle" />
    {children}
  </Button>
);

export default AddButton;



// WEBPACK FOOTER //
// ./src/components/addButton/addButton.jsx